import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, TextField } from '@material-ui/core';
import * as Actions from '../store/actions';

class GraderHeader extends Component {
    handleChange = (field_name) => (event) => {
        const { updateStudentQuiz } = this.props;
        let new_value = event.target.value;

        const update_data = {
            [field_name]: new_value
        }

        updateStudentQuiz(update_data);
    }

    handleBlur = (field_name) => (event) => {
        const { updateStudentQuiz } = this.props;
        let new_value = event.target.value;

        if (field_name === 'Score') {
            new_value = Math.abs(Number(new_value)).toFixed(1);

            if (isNaN(new_value)) {
                new_value = Number(0.00).toFixed(1);
            }
        }

        const update_data = {
            [field_name]: new_value
        }
        updateStudentQuiz(update_data);
    }

    render() {
        const { quiz, studentQuiz, classes } = this.props;

        if (typeof quiz === 'undefined') {
            return <div>Loading...</div>;
        }

        return (
            <div className="px-24">
                <Grid container spacing={24}>
                    <Grid item xs={3}>
                        <TextField
                            id="QuizName"
                            label="Quiz Name"
                            className={classes.textField}
                            value={quiz.header.QuizName}
                            margin="normal"
                            disabled
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <TextField
                            id="QuizDescription"
                            label="Quiz Description"
                            className={classes.textField}
                            value={quiz.header.QuizDescription}
                            style={{width: '90%'}}
                            margin="normal"
                            disabled
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="Student"
                            label="Student"
                            className={classes.textField}
                            value={studentQuiz.student.header.FirstName + " " + studentQuiz.student.header.LastName}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="Attempt"
                            label="Attempt"
                            className={classes.textField}
                            value={studentQuiz.header.Attempt + "/" + quiz.header.MaxAttempt}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="StartTime"
                            label="Start Time"
                            className={classes.textField}
                            value={studentQuiz.header.StartTime}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="EndTime"
                            label="End Time"
                            className={classes.textField}
                            value={studentQuiz.header.EndTime}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="CurrentGrade"
                            label="Current Grade"
                            className={classes.textField}
                            value={studentQuiz.header.Score}
                            onChange={this.handleChange('Score')}
                            onBlur={this.handleBlur('Score')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            id="TotalScore"
                            label="Max Points"
                            className={classes.textField}
                            value={quiz.header.TotalScore}
                            disabled
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateStudentQuiz: Actions.updateStudentQuiz,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GraderHeader)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizGrader/GraderHeader.js